/* TopNavi — Airtable header behavior
   Vanilla JS, no jQuery. Loaded with `defer` from layout/theme.liquid. */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    initMobileDrawer();
    initSearchOverlay();
    initStickyHeader();
    initMegaMenu();
    initPredictiveSearch();
    initMega2();
    // 2026-09-02: initDrawerPanels() innen kikerült — a panelek <template>-ben
    // várnak (sections/header.liquid), az első megnyitáskor ensureDrawerPanels()
    // klónozza be és inicializálja őket.
    initMenuImagePrefetch();
  }

  /* ---------------------------------------------------------------------
     DRAWER-PANELEK LUSTA BEKLÓNOZÁSA (2026-09-02, PSI DOM-méret)
     A mobil fiók 3 szintű, 171 képes panelrendszere (~1 270 DOM-elem) a
     header.liquid-ben <template data-dp-template>-ben ül: a betöltéskor nem
     DOM, nem stílusszámítás, nem képletöltés. Az első megnyitáskor ide
     klónozzuk (egyszer), és csak ekkor fut az initDrawerPanels().
     --------------------------------------------------------------------- */
  let drawerPanelsReady = false;
  function ensureDrawerPanels() {
    if (drawerPanelsReady) return;
    drawerPanelsReady = true;
    const tpl = document.querySelector('[data-dp-template]');
    if (!tpl) return;
    tpl.parentNode.insertBefore(tpl.content.cloneNode(true), tpl);
    tpl.remove();
    initDrawerPanels();
  }

  /* ---------------------------------------------------------------------
     MENÜKÉP-ELŐTÖLTÉS (2026-07-28) — a rejtett panelek lazy-képei csak
     akkor kezdenének töltődni, amikor a panel láthatóvá válik (márka-
     hover), ezért "lassúnak" érződik a menü. Stratégia:
       1. Oldalbetöltés utáni üresjáratban: a kis képek (márka-csempék,
          kártyák, foot/rail) előtöltése.
       2. Menü-szándéknál (mouseenter a nav-elemre): az összes modell-kép
          darabolt (idle) előtöltése — mire a látogató márkát választ,
          a képek már a cache-ben vannak.
       3. Panel-aktiváláskor (activate/show): az adott panel képei azonnal.
     A loading attribútum 'eager'-re váltása display:none alatt is elindítja
     a letöltést — nulla extra kérés, csak ütemezés.
     --------------------------------------------------------------------- */
  function eagerImgs(root) {
    if (!root) return;
    root.querySelectorAll('img[loading="lazy"]').forEach(img => { img.loading = 'eager'; });
  }

  function initMenuImagePrefetch() {
    const idle = window.requestIdleCallback
      ? cb => requestIdleCallback(cb, { timeout: 2500 })
      : cb => setTimeout(cb, 250);

    function chunked(root) {
      const imgs = Array.from(root ? root.querySelectorAll('img[loading="lazy"]') : []);
      let i = 0;
      (function step() {
        const end = Math.min(i + 14, imgs.length);
        for (; i < end; i++) imgs[i].loading = 'eager';
        if (i < imgs.length) idle(step);
      })();
    }

    // 1) Kis képek a teljes oldalbetöltés utáni üresjáratban
    function warmup() {
      idle(() => {
        document.querySelectorAll('.tn-megamenu').forEach(m => {
          eagerImgs(m.querySelector('.tn-mega2-side'));
          eagerImgs(m.querySelector('.tn-mega2-foot'));
          m.querySelectorAll('.tn-mega2-card-img, .tn-mega2-panel.is-active').forEach(el => eagerImgs(el));
        });
      });
    }
    // 2026-09-02 (PSI/Lighthouse mobil): a warmup EDDIG MINDEN eszközön lefutott —
    // mobilon is, ahol az asztali megamenü sosem nyílik meg (display:none), de az
    // `eager` átállítás display:none alatt is elindítja a letöltést. Mért hatás a
    // termékoldalon: 85 kollekció-kép, ~808 KB MINDEN mobil oldalletöltésen, a
    // galéria-képekkel és a követő-scriptekkel versenyezve. Mostantól csak
    // hover-képes, ≥1024px-es eszközön fut, és adatkímélő módban / 2g-3g
    // kapcsolaton ott sem. A 2) és 3) lépés változatlan: azok valódi
    // felhasználói szándékra (mouseenter / drawer-kattintás) indulnak.
    var tnConn = navigator.connection || {};
    var tnCanWarm = !!(window.matchMedia && window.matchMedia('(min-width: 1024px) and (hover: hover)').matches)
      && !tnConn.saveData
      && !/(^|-)[23]g$/.test(tnConn.effectiveType || '');
    if (tnCanWarm) {
      if (document.readyState === 'complete') warmup();
      else window.addEventListener('load', warmup, { once: true });
    }

    // 2) Menü-szándék: minden kép az adott lenyílóban, darabolva
    document.querySelectorAll('.tn-nav-item.has-dropdown').forEach(item => {
      item.addEventListener('mouseenter', () => {
        chunked(item.querySelector('.tn-megamenu') || item.querySelector('.tn-dropdown'));
      }, { once: true });
    });

    // 3) Mobil drawer nyitásakor: a teljes drawer darabolva
    const toggle = document.querySelector('[data-mobile-toggle]');
    const drawer = document.querySelector('[data-mobile-drawer]');
    // 2026-09-02: a teljes fiók (171 kép, ~1,3 MB) előtöltése csak gyors, nem
    // adatkímélő kapcsolaton — a megnyitott panel képeit a show() amúgy is
    // azonnal indítja (eagerImgs), ez csak a "következő szint" gyorsítása.
    // A click-kezelő az initMobileDrawer open()-je UTÁN fut (regisztrációs
    // sorrend), tehát a <template>-ből addigra beklónozott panelekre lát.
    var tnFast = !tnConn.saveData && !/(^|-)[23]g$/.test(tnConn.effectiveType || '');
    if (toggle && drawer && tnFast) {
      toggle.addEventListener('click', () => chunked(drawer), { once: true });
    }
  }

  /* ---------------------------------------------------------------------
     MOBILE DRAWER
     --------------------------------------------------------------------- */
  function initMobileDrawer() {
    const toggle = document.querySelector('[data-mobile-toggle]');
    const drawer = document.querySelector('[data-mobile-drawer]');
    const overlay = document.querySelector('[data-drawer-overlay]');
    if (!toggle || !drawer || !overlay) return;

    function open() {
      ensureDrawerPanels(); // 2026-09-02: a panelek első nyitáskor klónozódnak be
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded', 'true');
    }
    function close() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', open);
    overlay.addEventListener('click', close);
    drawer.querySelectorAll('[data-drawer-close]').forEach(el => el.addEventListener('click', close));
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    // 2026-07-28: a régi accordion-ág ([data-submenu-toggle]) törölve —
    // a 2026-07-21-es panel-drawer óta nem létezik ilyen markup.
  }

  /* ---------------------------------------------------------------------
     SEARCH OVERLAY
     --------------------------------------------------------------------- */
  function initSearchOverlay() {
    const triggers = document.querySelectorAll('[data-search-toggle]');
    const overlay = document.querySelector('[data-search-overlay]');
    if (!triggers.length || !overlay) return;
    const input = overlay.querySelector('[data-search-input]');
    const panel = overlay.querySelector('.tn-search-panel');

    function updatePanelPadding() {
      const header = document.querySelector('.tn-header');
      if (!header || !panel) return;
      const bottom = Math.max(0, header.getBoundingClientRect().bottom);
      panel.style.paddingTop = (bottom + 28) + 'px';
    }

    function open() {
      updatePanelPadding();
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (input) setTimeout(() => input.focus(), 80);
    }
    function close() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    // 2026-07-12 (browser-review): a scroll-listener törölve — a panel
    // position:fixed, a header sticky, így a header alsó éle nem mozdul, amíg
    // az overlay nyitva van; az open()-kori egyszeri mérés + resize elegendő.
    // (iOS Safarin a body overflow:hidden nem állítja meg a scrollt, ott ez
    // minden scroll-frame-en forced layout + relayout volt.)
    window.addEventListener('resize', updatePanelPadding);

    triggers.forEach(t => t.addEventListener('click', open));
    overlay.querySelectorAll('[data-search-close]').forEach(el => el.addEventListener('click', close));
    overlay.addEventListener('click', e => {
      if (e.target === overlay) close();
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });

    // Expose toggle for header inline icons (legacy compatibility)
    window.toggleSearch = function () {
      overlay.classList.contains('is-open') ? close() : open();
    };
  }

  /* ---------------------------------------------------------------------
     STICKY HEADER (shadow on scroll)
     --------------------------------------------------------------------- */
  function initStickyHeader() {
    const header = document.querySelector('[data-at-header]');
    if (!header) return;
    let last = 0;
    function onScroll() {
      const y = window.scrollY;
      if (y > 12 && last <= 12) header.classList.add('is-scrolled');
      else if (y <= 12 && last > 12) header.classList.remove('is-scrolled');
      last = y;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------------------------------------------------------------
     MEGA-MENU — aria-expanded szinkron a CSS-hover nyitáshoz (2026-07-28).
     A régi `no-delay` osztály-togglet töröltük: egyetlen .tn-* CSS-szabály
     sem használta (csak az inaktív turbo-header réteg). A nyitás/zárás
     továbbra is tisztán CSS (:hover/:focus-within) — ez csak a képernyő-
     olvasóknak jelzi az állapotot.
     --------------------------------------------------------------------- */
  function initMegaMenu() {
    document.querySelectorAll('.tn-nav-item.has-dropdown').forEach(item => {
      const link = item.querySelector(':scope > .tn-nav-link');
      if (!link) return;
      link.setAttribute('aria-expanded', 'false');
      const set = v => link.setAttribute('aria-expanded', v);
      item.addEventListener('mouseenter', () => set('true'));
      item.addEventListener('mouseleave', () => set('false'));
      item.addEventListener('focusin', () => set('true'));
      item.addEventListener('focusout', e => {
        if (!item.contains(e.relatedTarget)) set('false');
      });
    });
  }

  /* ---------------------------------------------------------------------
     MEGA2 — kétpaneles megamenü (2026-07-21): márkára hoverelve/fókuszálva
     a jobb oldali modell-panel vált; a kereső a márkalistát szűri.
     Markup: snippets/tn-mega-2026.liquid, stílus: assets/tn-menu.css.
     --------------------------------------------------------------------- */
  function initMega2() {
    document.querySelectorAll('[data-mega2]').forEach(mega => {
      const brands = mega.querySelectorAll('[data-mega2-brand]');
      const panels = mega.querySelectorAll('[data-mega2-panel]');

      function activate(key) {
        brands.forEach(b => b.classList.toggle('is-active', b.dataset.mega2Brand === key));
        panels.forEach(p => {
          const on = p.dataset.mega2Panel === key;
          if (on) eagerImgs(p); // a célpanel képei azonnal induljanak
          p.classList.toggle('is-active', on);
        });
      }

      // Hover-intent: 90ms késleltetéssel vált, így a márkalistáról a
      // modell-kártyák felé húzott (átlós) egérmozgás közben érintett
      // sorok NEM váltják el a panelt (klasszikus megamenü-hiba).
      let hoverTimer = null;
      brands.forEach(b => {
        b.addEventListener('mouseenter', () => {
          clearTimeout(hoverTimer);
          // A képek letöltése már a hover-intent ELŐTT induljon
          eagerImgs(mega.querySelector('[data-mega2-panel="' + CSS.escape(b.dataset.mega2Brand) + '"]'));
          hoverTimer = setTimeout(() => activate(b.dataset.mega2Brand), 90);
        });
        b.addEventListener('mouseleave', () => clearTimeout(hoverTimer));
        b.addEventListener('focus', () => activate(b.dataset.mega2Brand));
      });

      /* Kereső (2026-07-21 user-kérés): márkán túl MODELLT is találjon;
         ha egyik sincs, TERMÉK-javaslatot ad (márkaspecifikus multimédia
         előre sorolva). A modell-index a már renderelt kártyákból épül —
         nulla extra adat, a találat a kártya klónja. */
      const input = mega.querySelector('[data-mega2-filter]');
      const empty = mega.querySelector('[data-mega2-empty]');
      const resModels = mega.querySelector('[data-mega2-search-models]');
      const resProds = mega.querySelector('[data-mega2-search-products]');
      const resNone = mega.querySelector('[data-mega2-search-none]');
      const resTitle = mega.querySelector('[data-mega2-search-title]');

      const modelIndex = [];
      panels.forEach(p => {
        if (p.dataset.mega2Panel === '__search') return;
        const brandEl = mega.querySelector('[data-mega2-brand="' + CSS.escape(p.dataset.mega2Panel) + '"]');
        const brandName = brandEl ? (brandEl.dataset.brandName || '') : '';
        p.querySelectorAll('.tn-mega2-models > li').forEach(li => {
          modelIndex.push({ text: (brandName + ' ' + li.textContent).toLowerCase(), li: li });
        });
      });

      if (input) {
        let prodTimer = null;
        const defaultBrand = mega.querySelector('.tn-mega2-brand.is-active');
        const defaultKey = defaultBrand ? defaultBrand.dataset.mega2Brand : (brands[0] ? brands[0].dataset.mega2Brand : '');
        const resultsLabel = resTitle ? resTitle.textContent : '';
        input.addEventListener('input', () => {
          const q = input.value.trim().toLowerCase();
          clearTimeout(prodTimer);
          let visible = 0;
          brands.forEach(b => {
            const li = b.closest('li');
            const match = !q || (b.dataset.brandName || '').includes(q);
            if (li) li.classList.toggle('is-hidden', !match);
            if (match) visible++;
          });
          if (empty) empty.hidden = true;
          if (resNone) resNone.hidden = true;

          if (!q) {
            if (resModels) { resModels.hidden = true; resModels.innerHTML = ''; }
            if (resProds) { resProds.hidden = true; resProds.innerHTML = ''; }
            if (defaultKey) activate(defaultKey);
            return;
          }

          const modelHits = modelIndex.filter(m => m.text.includes(q)).slice(0, 8);
          if (resTitle) resTitle.textContent = resultsLabel + ': „' + input.value.trim() + '”';

          if (modelHits.length) {
            resModels.innerHTML = '';
            modelHits.forEach(m => resModels.appendChild(m.li.cloneNode(true)));
            resModels.hidden = false;
            if (resProds) { resProds.hidden = true; resProds.innerHTML = ''; }
            activate('__search');
          } else if (visible > 0) {
            // Márka-találat van, modell nincs: az első látható márka panelje
            if (resModels) { resModels.hidden = true; resModels.innerHTML = ''; }
            if (resProds) { resProds.hidden = true; resProds.innerHTML = ''; }
            const first = mega.querySelector('.tn-mega2-brands li:not(.is-hidden) [data-mega2-brand]');
            if (first) activate(first.dataset.mega2Brand);
          } else {
            // Se márka, se modell: termék-javaslat (rövid késleltetéssel)
            resModels.hidden = true; resModels.innerHTML = '';
            activate('__search');
            prodTimer = setTimeout(() => {
              suggestProducts(input.value.trim(), resProds, resNone);
            }, 250);
          }
        });
        input.addEventListener('click', e => e.stopPropagation());
      }
    });
  }

  /* Termék-javaslatok a menü-keresőkbe: /search/suggest.json, a
     "Márkaspecifikus multimédia" vendor előre sorolva (user-kérés), a
     meglévő .at-search-result stílusokat újrahasznosítva. */
  function suggestProducts(query, container, noneEl) {
    if (!container) return;
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8')
      .then(r => r.json())
      .then(data => {
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        products.sort((a, b) => vendorPriority(b.vendor) - vendorPriority(a.vendor));
        if (!products.length) {
          container.hidden = true;
          container.innerHTML = '';
          if (noneEl) noneEl.hidden = false;
          return;
        }
        if (noneEl) noneEl.hidden = true;
        container.innerHTML = products.map(p => `
          <a href="${p.url}" class="at-search-result">
            <div class="at-search-result-image">
              <img src="${p.image}" alt="${escapeHtml(p.title)}" loading="lazy" width="56" height="56">
            </div>
            <div class="at-search-result-info">
              <div class="at-search-result-title">${escapeHtml(p.title)}</div>
              <div class="at-search-result-price">${formatPrice(p.price)}</div>
            </div>
          </a>`).join('');
        container.hidden = false;
      })
      .catch(() => { /* hálózati hiba: a kereső némán marad, a menü működik */ });
  }

  /* ---------------------------------------------------------------------
     DRAWER PANELS — mobil csúszó-paneles menü (2026-07-21): a mélyebb
     szint teljes panelként csúszik be, "← Vissza" léptet visszafelé.
     Markup: snippets/tn-drawer-panels.liquid, stílus: assets/tn-menu.css.
     --------------------------------------------------------------------- */
  function initDrawerPanels() {
    const dp = document.querySelector('[data-dp]');
    if (!dp) return;
    const panels = dp.querySelectorAll('[data-dp-panel]');
    let stack = ['root'];

    function show(id) {
      const next = dp.querySelector('[data-dp-panel="' + CSS.escape(id) + '"]');
      if (!next) return;
      eagerImgs(next); // a célpanel képei azonnal induljanak
      panels.forEach(p => p.classList.remove('is-active', 'is-left'));
      // A vissza-útvonal paneljei balra "parkolnak" (mélység-érzet)
      stack.slice(0, -1).forEach(backId => {
        const back = dp.querySelector('[data-dp-panel="' + CSS.escape(backId) + '"]');
        if (back) back.classList.add('is-left');
      });
      next.classList.add('is-active');
      next.scrollTop = 0;
    }

    dp.addEventListener('click', e => {
      const opener = e.target.closest('[data-dp-open]');
      if (opener) {
        e.preventDefault();
        stack.push(opener.dataset.dpOpen);
        show(opener.dataset.dpOpen);
        return;
      }
      const back = e.target.closest('[data-dp-back]');
      if (back) {
        e.preventDefault();
        if (stack.length > 1) stack.pop();
        show(stack[stack.length - 1]);
      }
    });

    // 2026-07-21 user-kérés: a menü rögtön a márkalistával nyíljon —
    // a data-dp-default panel az induló nézet (a "Főmenü" vissza-sáv
    // vezet a többi menüponthoz); zárás után is ide áll vissza.
    const defPanel = dp.querySelector('[data-dp-panel][data-dp-default]');
    function goDefault() {
      if (defPanel) {
        stack = ['root', defPanel.dataset.dpPanel];
        show(defPanel.dataset.dpPanel);
      } else {
        stack = ['root'];
        show('root');
      }
    }
    goDefault();
    function resetSoon() { setTimeout(goDefault, 320); }
    document.querySelectorAll('[data-drawer-close], [data-drawer-overlay]').forEach(el => {
      el.addEventListener('click', resetSoon);
    });

    // Kereső a mobil márkapanelen: márka + modell találatok, végső
    // esetben termék-javaslat (desktoppal azonos logika, sor-formában).
    dp.querySelectorAll('[data-dp-filter]').forEach(input => {
      const panel = input.closest('[data-dp-panel]');
      if (!panel) return;
      const rows = panel.querySelectorAll('[data-dp-filter-list] li[data-brand-name]');
      const empty = panel.querySelector('[data-dp-empty]');
      const resModels = panel.querySelector('[data-dp-search-models]');
      const resProds = panel.querySelector('[data-dp-search-products]');

      // Modell-index a márka-alpanelek már renderelt soraiból
      const modelIndex = [];
      dp.querySelectorAll('[data-dp-panel^="b-"]').forEach(bp => {
        const backLabel = bp.querySelector('[data-dp-back] span');
        const brandName = backLabel ? backLabel.textContent.toLowerCase() : '';
        bp.querySelectorAll('.tn-dp-list > li').forEach(li => {
          modelIndex.push({ text: (brandName + ' ' + li.textContent).toLowerCase(), li: li });
        });
      });

      let prodTimer = null;
      input.addEventListener('input', () => {
        const q = input.value.trim().toLowerCase();
        clearTimeout(prodTimer);
        let visible = 0;
        rows.forEach(li => {
          const match = !q || (li.dataset.brandName || '').includes(q);
          li.style.display = match ? '' : 'none';
          if (match) visible++;
        });
        if (empty) empty.hidden = true;

        if (!q) {
          if (resModels) { resModels.hidden = true; resModels.innerHTML = ''; }
          if (resProds) { resProds.hidden = true; resProds.innerHTML = ''; }
          return;
        }

        const modelHits = modelIndex.filter(m => m.text.includes(q)).slice(0, 8);
        if (resModels) {
          resModels.innerHTML = '';
          modelHits.forEach(m => resModels.appendChild(m.li.cloneNode(true)));
          resModels.hidden = modelHits.length === 0;
        }

        if (!visible && !modelHits.length) {
          prodTimer = setTimeout(() => {
            suggestProducts(input.value.trim(), resProds, empty);
          }, 250);
        } else if (resProds) {
          resProds.hidden = true;
          resProds.innerHTML = '';
        }
      });
    });
  }

  /* 2026-07-28: initBrandFilter törölve — a [data-brand-filter] markup csak
     az inaktív mega-menu-modern.liquid-ben létezett (2026-07-21 óta halott). */

  /* ---------------------------------------------------------------------
     PREDICTIVE SEARCH — preserves CR-V/CX-5 normalization from legacy
     --------------------------------------------------------------------- */
  // Márkák / rövidítések, amiket NE alakítson át a normalizer
  const NEVER_NORMALIZE = new Set([
    'BMW','AMG','AUDI','OPEL','KIA','VW','SEAT','TDI','TSI','TFSI','GTD','FSI','GTI','GTS','GTR','GTX',
    'AWD','FWD','RWD','SUV','HEV','PHEV','EV','MID','HQ','HD','USB','GPS','DSP','DAB','LED','OEM',
    'ECO','MPV','RS','RS3','RS4','RS5','RS6','RS7'
  ]);
  // Csak ezek a 3-betűs prefixek kapnak CR-V stílusú kötőjelezést
  const KNOWN_V_PREFIXES = new Set(['CR','HR','BR','ZR','WR','XR']);

  function normalizeCarModelQuery(raw) {
    const q = raw.trim();
    // Ha az input MÁR strukturált (tartalmaz szóközt, kötőjelet, vagy pontot),
    // a user explicit "márka + modell" formát írt — tiszteletben tartjuk és
    // változatlanul küldjük tovább. ("Audi A3", "BMW E46", "Toyota RAV4", "CR-V" stb.)
    if (/[\s\-\.]/.test(q)) return q;

    // Csak ezután fut a model-kód normalizáló — pl. "CRV" → "CR-V", "CX5" → "CX-5".
    const clean = q.toUpperCase();
    if (NEVER_NORMALIZE.has(clean)) return q;
    const map = {
      'CRV': 'CR-V', 'HRV': 'HR-V', 'BRV': 'BR-V', 'ZRV': 'ZR-V', 'WRV': 'WR-V',
      'CX5': 'CX-5', 'CX3': 'CX-3', 'CX30': 'CX-30', 'CX60': 'CX-60', 'CX90': 'CX-90',
      'RAV4': 'RAV 4', 'CHR': 'C-HR', 'TROC': 'T-Roc', 'TCROSS': 'T-Cross',
    };
    if (map[clean]) return map[clean];
    if (clean.length === 3 && clean.endsWith('V') && KNOWN_V_PREFIXES.has(clean.slice(0, 2))) {
      return clean.slice(0, 2) + '-V';
    }
    const m = clean.match(/^([A-Z]{1,5})([0-9]{1,3})([A-Z]{0,2})$/);
    if (m) return m[1] + '-' + m[2] + (m[3] ? ' ' + m[3] : '');
    return q;
  }

  function formatPrice(rawPrice) {
    let formatted = String(rawPrice);
    if (!/^[\d\s.,]+$/.test(formatted.trim())) return formatted;
    const cleanStr = formatted.replace(/\s/g, '').replace(',', '.');
    const value = parseFloat(cleanStr);
    if (isNaN(value)) return formatted;
    const cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'HUF';
    if (cur === 'HUF') return new Intl.NumberFormat('hu-HU', { style: 'decimal', maximumFractionDigits: 0 }).format(value) + ' Ft';
    if (cur === 'EUR') return '€' + value.toFixed(2).replace('.', ',');
    if (cur === 'RON') return value.toFixed(0) + ' Lei';
    if (cur === 'PLN') return value.toFixed(2).replace('.', ',') + ' zł';
    return value + ' ' + cur;
  }

  function vendorPriority(vendor) {
    if (vendor === 'Márkaspecifikus multimédia') return 2;
    if (vendor === 'Márkaspecifikus tolatókamera') return 1;
    return 0;
  }

  function initPredictiveSearch() {
    const input = document.querySelector('[data-search-input]');
    const results = document.querySelector('[data-search-results]');
    const searchUrl = (document.documentElement.dataset.searchUrl) || '/search';
    const strings = (window.theme && window.theme.strings && window.theme.strings.custom && window.theme.strings.custom.search) || {
      view_all: 'View all', no_results: 'No results found', min_chars: 'Type at least 2 characters',
    };
    if (!input || !results) return;

    let timer;
    input.addEventListener('input', e => {
      clearTimeout(timer);
      timer = setTimeout(() => runSearch(e.target.value), 120);
    });

    function runSearch(rawQuery) {
      const original = rawQuery.trim();
      const primary  = normalizeCarModelQuery(rawQuery);
      if (original.length === 0) {
        results.innerHTML = '';
        results.classList.remove('is-visible');
        return;
      }
      if (original.length === 1) {
        results.innerHTML = `<div class="at-search-empty">${strings.min_chars}</div>`;
        results.classList.add('is-visible');
        return;
      }

      // Query variánsok — az ORIGINAL legyen az ELSŐ (legnagyobb relevancia),
      // utána a normalize-elt (ha más), végül szóköz/kötőjel-mentes fallback.
      const variants = [original];
      if (primary && primary !== original) variants.push(primary);
      const stripped = original.replace(/[\s\-\.]/g, '');
      if (stripped !== original && stripped.length > 1 && !variants.includes(stripped)) {
        variants.push(stripped);
      }

      // Loading állapot azonnal látszódjék, ne villogjon a régi tartalom
      results.innerHTML = `
        <div class="tn-loader-wrap" role="status" aria-live="polite">
          <div class="tn-loader-dots"><span></span><span></span><span></span></div>
          <p class="tn-loader-text">Keresés folyamatban…</p>
        </div>`;
      results.classList.add('is-visible');

      Promise.all(variants.map(v =>
        fetch(`/search/suggest.json?q=${encodeURIComponent(v)}&resources[type]=product&resources[limit]=10`).then(r => r.json())
      )).then(allData => {
        const seen = new Set();
        const products = [];
        // Az első variáns (= original) találatai kerülnek elsőként a tömbbe;
        // a további variánsok csak új ID-ket adnak hozzá.
        for (const data of allData) {
          for (const p of (data.resources && data.resources.results && data.resources.results.products) || []) {
            if (!seen.has(p.id)) { seen.add(p.id); products.push(p); }
          }
        }
        if (!products.length) {
          results.innerHTML = `<div class="at-search-empty">${strings.no_results}</div>`;
          results.classList.add('is-visible');
          return;
        }

        // === RELEVANCIA RENDEZÉS ===
        // 1. EXACT title-match (a teljes original query benne van a title-ban)
        // 2. Vendor priority (Márkaspecifikus multimédia = 2, tolatókamera = 1)
        // 3. Eredeti API-sorrend (Shopify saját relevancia)
        const origLower = original.toLowerCase();
        const origNoSpace = origLower.replace(/\s+/g, '');
        products.forEach((p, i) => {
          const tLower = String(p.title || '').toLowerCase();
          const tNoSpace = tLower.replace(/\s+/g, '');
          p.__titleHit = tLower.includes(origLower) || tNoSpace.includes(origNoSpace);
          p.__origIdx = i; // tie-breaker
        });
        products.sort((a, b) => {
          // 1. Title-mátch elöl
          if (a.__titleHit !== b.__titleHit) return a.__titleHit ? -1 : 1;
          // 2. Vendor priority
          const vp = vendorPriority(b.vendor) - vendorPriority(a.vendor);
          if (vp !== 0) return vp;
          // 3. Stabil sorrend
          return a.__origIdx - b.__origIdx;
        });

        const productsHtml = products.map(p => `
          <a href="${p.url}" class="at-search-result">
            <div class="at-search-result-image">
              <img src="${p.image}" alt="${escapeHtml(p.title)}" loading="lazy" width="80" height="80">
            </div>
            <div class="at-search-result-info">
              <div class="at-search-result-title">${escapeHtml(p.title)}</div>
              <div class="at-search-result-price">${formatPrice(p.price)}</div>
            </div>
            <svg class="at-search-result-arrow" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
              <path fill="currentColor" d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/>
            </svg>
          </a>`).join('');
        // "Összes találat megtekintése" — AZ EREDETI query az URL-ben és a label-ben
        const viewAllHtml = `
          <a href="${searchUrl}?q=${encodeURIComponent(original)}&type=product" class="at-search-view-all">
            <span>${strings.view_all} ("${escapeHtml(original)}")</span>
            <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
              <path fill="currentColor" d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/>
            </svg>
          </a>`;
        results.innerHTML = productsHtml + viewAllHtml;
        results.classList.add('is-visible');
      }).catch(err => {
        console.error('Search error:', err);
      });
    }
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, m => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[m]));
  }
})();
